import { getPaletteColor, hexToRgb } from '..';
export var boxShadowSizeValues = ['sm', 'md', 'lg', 'xl', '2xl', 'overlay-lg', 'overlay-xl'];
function calculateShadowProps(effectiveShadow, effectiveColor) {
    if (effectiveColor) {
        var rgb = hexToRgb(effectiveColor);
        return effectiveShadow.replace('rgba(0,0,0,', "".concat(rgb.slice(0, rgb.length - 1), ", "));
    }
    return effectiveShadow;
}
export function boxShadowAttrs(props) {
    var boxShadowSize = props.boxShadowSize, boxShadowColor = props.boxShadowColor, theme = props.theme;
    if (!boxShadowSize) {
        return {};
    }
    var effectiveColor;
    if (boxShadowColor) {
        var baseColor = boxShadowColor.split('.')[0];
        var shadowColor = "".concat(baseColor, ".dark");
        effectiveColor = getPaletteColor(shadowColor)(props);
    }
    if (Array.isArray(boxShadowSize)) {
        var effectiveShadow = boxShadowSize.map(function (size) { return theme.shadows[size]; });
        var shadows = effectiveShadow.map(function (shadow) { return calculateShadowProps(shadow, effectiveColor); });
        return {
            boxShadow: shadows,
        };
    }
    else {
        var effectiveShadow = theme.shadows[boxShadowSize];
        return {
            boxShadow: calculateShadowProps(effectiveShadow, effectiveColor),
        };
    }
}
//# sourceMappingURL=boxShadowAttrs.js.map